const PRELOAD_RECOVERY_KEY = 'travel.preload-recovery-at';
const PRELOAD_RECOVERY_WINDOW_MS = 30_000;

type RecoveryEnvironment = {
  storage: Pick<Storage, 'getItem' | 'setItem'>;
  reload: () => void;
  now: () => number;
};

function browserEnvironment(): RecoveryEnvironment {
  return {
    storage: window.sessionStorage,
    reload: () => window.location.reload(),
    now: () => Date.now(),
  };
}

/**
 * Vite emits `vite:preloadError` when an already-open tab asks for a route
 * chunk removed by a newer deployment. Reload once so the tab receives the
 * new index and chunk manifest. A short guard keeps a genuine network failure
 * from turning into an endless reload loop.
 */
export function recoverFromStalePreload(
  event: Event,
  environment: RecoveryEnvironment = browserEnvironment(),
) {
  const now = environment.now();
  const previous = Number(environment.storage.getItem(PRELOAD_RECOVERY_KEY));
  if (Number.isFinite(previous) && previous > 0 && now - previous < PRELOAD_RECOVERY_WINDOW_MS) {
    return false;
  }
  environment.storage.setItem(PRELOAD_RECOVERY_KEY, String(now));
  event.preventDefault();
  environment.reload();
  return true;
}

export function installPreloadRecovery() {
  window.addEventListener('vite:preloadError', recoverFromStalePreload);
}
